import React, { useEffect, useState } from 'react';
import GridInputs from '../../components/common/inputs/GridInputs';
import { IData } from './helpers/Interface';
import axios from 'axios';
import { SubmitButton } from '../../components/common/button/CustomButtons';
import useConfirm from '../../components/common/useConfirm';
import AutocompleteGridmui from '../../components/common/autocomplete/AutocompleteGridmui';
import { tagData } from './constant';
import DateGridMui from '../../components/common/dateCustom/DateGridMui';
import moment from 'moment';

const Create = ({
  id,
  setIsModal,
}: {
  id?: string | null;
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const [customerData, setCustomerData] = useState<IData>({
    part_code: '',
    part_name: '',
    part_obj: '',
    customer_name: '',
    bin_type: '',
    bin_size: '',
    qty: null,
    invoice_no: '',
    contact: '',
    invoice_date: '',
    total_qty: null,
    no_of_tags: null,
  });

  const [isSubmit, setIsSubmit] = useState(false);
  const [render, setRender] = useState(false);

  const [DialogSubmit, confirmSubmit] = useConfirm(
    `${id ? 'Update Tag' : 'Create Tag'}`,
    `Are you sure you want to ${id ? 'update' : 'save'} this?`
  );
  useEffect(() => {
    if (id) {
      axios
        .get(`/api/tagRoute/${id}`)
        .then((res) => {
          const getObj = tagData.filter(
            (item) => item.part_code === res?.data?.part_code
          );
          setCustomerData({ ...res.data, part_obj: getObj[0] });
        })
        .catch((err) => console.log(err));
    }
  }, [id]);

  function handleCustomerData(e: React.ChangeEvent<HTMLInputElement>) {
    setCustomerData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  }

  const handleSumbit = async () => {
    setIsSubmit(true);
    const ans = await confirmSubmit();
    if (!ans) return;
    if (id) {
      await axios
        .put(`/api/tagRoute/${id}`, customerData)
        .then((res) => {
          setIsSubmit(false);
          setIsModal(false);
        })
        .catch((err) => console.log(err));
    } else {
      await axios
        .post('/api/tagRoute', customerData)
        .then((res) => {
          setIsSubmit(false);
          setIsModal(false);
        })
        .catch((err) => {
          setIsSubmit(false);
          console.log(err);
        });
    }
  };

  return (
    <>
      <AutocompleteGridmui
        label={'Part Name'}
        id={'part_name'}
        option_name={'part_name'}
        value={customerData.part_obj || ''}
        arrayofObj={tagData}
        onChange={(e, value) => {
          customerData.part_obj = value;
          customerData.part_name = value?.part_name;
          customerData.part_code = value?.part_code;
          customerData.customer_name = value?.customer_name;
          customerData.bin_type = value?.bin_type;
          customerData.bin_size = value?.bin_size;
          customerData.qty = value?.qty;

          const qty = customerData?.qty || 0;
          const total_qty = customerData?.total_qty || 0;
          customerData.no_of_tags = Math.floor(total_qty / qty);
          setRender((prev) => !prev);
        }}
      />

      <GridInputs
        id={'part_code'}
        name={'part_code'}
        html_for={'part_code'}
        label_name={'Part Code:'}
        input_type={'text'}
        focusType={'onchange'}
        value={customerData?.part_code || ''}
      />
      <GridInputs
        id={'customer_name'}
        name={'customer_name'}
        html_for={'customer_name'}
        label_name={'Customer Name:'}
        input_type={'text'}
        focusType={'onchange'}
        value={customerData?.customer_name || ''}
      />
      <GridInputs
        id={'bin_type'}
        name={'bin_type'}
        html_for={'bin_type'}
        label_name={'BIN TYPE:'}
        input_type={'text'}
        focusType={'onchange'}
        value={customerData?.bin_type || ''}
      />
      <GridInputs
        id={'bin_size'}
        name={'bin_size'}
        html_for={'bin_size'}
        label_name={'BIN SIZE:'}
        input_type={'text'}
        focusType={'onchange'}
        value={customerData?.bin_size || ''}
      />
      <GridInputs
        id={'qty'}
        name={'qty'}
        html_for={'qty'}
        label_name={'Qty:'}
        input_type={'number'}
        focusType={'onchange'}
        value={customerData?.qty || ''}
      />

      <GridInputs
        id={'invoice_no'}
        name={'invoice_no'}
        html_for={'invoice_no'}
        label_name={'Invoice No:'}
        input_type={'text'}
        focusType={'onblur'}
        value={customerData?.invoice_no || ''}
        onChange={handleCustomerData}
        last_child={2}
      />

      <DateGridMui
        lable="Date:"
        onChange={(date: any) => {
          customerData.invoice_date = date;
          setRender((prev) => !prev);
        }}
        value={moment(customerData.invoice_date) || null}
      />

      <GridInputs
        id={'total_qty'}
        name={'total_qty'}
        html_for={'total_qty'}
        label_name={'Total Qty:'}
        input_type={'number'}
        focusType={'onchange'}
        value={customerData?.total_qty || ''}
        onChange={(e) => {
          customerData.total_qty = +e.target.value;
          const qty = customerData?.qty || 0;
          customerData.no_of_tags = Math.floor(customerData.total_qty / qty);
          setRender((prev) => !prev);
        }}
        last_child={2}
      />
      <GridInputs
        id={'no_of_tags'}
        name={'no_of_tags'}
        html_for={'no_of_tags'}
        label_name={'No of tags:'}
        input_type={'number'}
        focusType={'onchange'}
        value={customerData?.no_of_tags || ''}
        last_child={2}
      />

      <div
        className="btn_save"
        style={{
          position: 'absolute',
          right: '140px',
          top: '-0.6px',
        }}
      >
        <SubmitButton
          label={`${id ? 'update' : 'submit'}`}
          type="button"
          onClick={handleSumbit}
        />
      </div>
      <DialogSubmit />
    </>
  );
};

export default Create;
